import script from "./ShareButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./ShareButton.vue?vue&type=script&setup=true&lang=ts"

import "./ShareButton.vue?vue&type=style&index=0&id=3784fdc3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3784fdc3"]])

export default __exports__